import React, { FC } from 'react'
import { Space } from 'antd'
import './title.scss'
const Title: FC = ({ children }) => {
  return (
    <div className="dashboard-title">
      <Space size={20}>{children}</Space>
    </div>
  )
}

export default Title
